




































































































































import { getModule } from "vuex-module-decorators";
import { Component, Vue } from "vue-property-decorator";
import HelloWorld from "@/components/HelloWorld.vue";

import ConnectionStore from "@/store/ConnectionStore";
import ConnectionGroup from "@/data/ConnectionGroup";

@Component({})
export default class VUEDebug extends Vue {
    public mounted(){
        console.log( this.$route );
    }
}

